import { render } from "./FavoritePageButton.vue?vue&type=template&id=05a1bf69&scoped=true"
import script from "./FavoritePageButton.vue?vue&type=script&lang=js"
export * from "./FavoritePageButton.vue?vue&type=script&lang=js"

import "./FavoritePageButton.vue?vue&type=style&index=0&id=05a1bf69&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a1bf69"]])

export default __exports__